import React, { useState } from "react";
import {
  Input as InputReactStrap,
  Modal as ModalReactStrap,
  Form,
} from "reactstrap";
import { useHistory } from "react-router-dom";

interface Props {
  modalSearch: boolean;
  toggleModalSearch: () => void;
}

export const SearchModal: React.FC<Props> = ({
  modalSearch,
  toggleModalSearch,
}) => {
  const [searchTxt, setSearchTxt] = useState("");
  const history = useHistory();

  const onEnter = (e: any) => {
    e.preventDefault();
    history.push(`/account/${searchTxt}`);
    toggleModalSearch();
  };
  const onChange = (e: any) => {
    setSearchTxt(e.target.value);
  };

  return (
    <ModalReactStrap
      modalClassName="modal-search"
      isOpen={modalSearch}
      toggle={toggleModalSearch}
    >
      <div className="modal-header">
        <Form onSubmitCapture={onEnter} style={{ width: "90%" }}>
          <InputReactStrap
            id="inlineFormInputGroup"
            placeholder="Search by Address or delegate"
            type="text"
            onChange={onChange}
          />
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={toggleModalSearch}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
        </Form>
      </div>
    </ModalReactStrap>
  );
};
